class ProductVariantsProperty extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['input', 'item', 'icon', 'title', 'variantId']
  }

  static get requiredExternalElements () {
    return ['icon', 'title', 'trigger']
  }

  connectedCallback () {
    super.connectedCallback()

    const activeItem = this.els.item.elements.find(el =>
      el.classList.contains(this.activeItemClass),
    )

    if (activeItem) {
      this.els.input.element.value = activeItem?.dataset?.value
      this.els.variantId.element.value = activeItem?.dataset?.variantId
    }
  }

  checkValidity () {
    super.checkValidity()

    if (!this.activeItemClass) {
      this.throwError(
        `You need to supply an 'data-active-item-class="Something"' property`,
      )
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.onItemClick)
  }

  onItemClick (e) {
    const item = e.target.closest(this.els.item.selector)
    if (!item) return
    if (item.getAttribute('aria-disabled') === 'true') return

    this.els.item.elements.forEach(i =>
      i.classList.toggle(this.activeItemClass, i === item),
    )

    const icon = item.querySelector(this.els.icon.selector)

    this.externalEls.icon.element.innerHTML = icon.innerHTML
    this.externalEls.title.element.textContent = this.externalEls.title.element.dataset.title.replace(
      '[[value]]',
      item.dataset.value,
    )

    this.els.input.element.value = item.dataset.value
    this.els.variantId.element.value = item.dataset.variantId

    window.drawers.close()
  }

  get activeItemClass () {
    return this.dataset.activeItemClass
  }
}

if (!customElements.get('product-variants-property')) {
  customElements.define('product-variants-property', ProductVariantsProperty)
}
